interface MatchProps {
    color?: 'Default' | 'White'; 
}

const MATCH_COLOR_SCHEMES = {
    Default: '#6B6B6B',
    White: '#FFFFFF'
};

export const Match: React.FC<MatchProps> = ({ color: colorScheme = 'Default' }) => {
    const color = MATCH_COLOR_SCHEMES[colorScheme]; 

    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_249_50665)">
                <path 
                    d="M10.833 11.719V18.334H3.33301C3.33292 17.3881 3.53412 16.453 3.92323 15.5909C4.31234 14.7287 4.88047 13.9592 5.58986 13.3336C6.29924 12.7079 7.13365 12.2403 8.03765 11.9619C8.94165 11.6836 9.89454 11.6007 10.833 11.719ZM9.99967 10.834C7.23717 10.834 4.99967 8.59648 4.99967 5.83398C4.99967 3.07148 7.23717 0.833984 9.99967 0.833984C12.7622 0.833984 14.9997 3.07148 14.9997 5.83398C14.9997 8.59648 12.7622 10.834 9.99967 10.834ZM14.8272 16.5956L17.773 13.6498L18.9522 14.8281L14.8272 18.9531L11.8805 16.0065L13.0597 14.8281L14.8263 16.5956H14.8272Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_249_50665">
                    <rect width="20" height="20" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
};
